// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 501 ? "bc98253f" : chunkId) + "." + {"501":"7e63d871e474c3ee","2931":"1d3afd6fd06bac47","4199":"1a79449f470923e1"}[chunkId] + ".js";
};